import ApexCharts from 'apexcharts'

window.addEventListener('load', (event) => {
    const ctx = document.getElementById('spendCalcChart');

    if (ctx) {

        var options = {
            chart: {
                type: "donut",
                height: '400'
            },
            
            series: window.chartJson.series,
            labels: window.chartJson.labels,
            tooltip: {
                y: {
                    formatter: (value) => {
                        return `$${numberWithCommas(value)}`;
                    }
                }
            },
            plotOptions: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            name: {
                                formatter: (value) => {
                                    const maxLength = 20;
                                    if(value.length > maxLength) {
                                        return value.substring(0, maxLength) + '...';
                                    }
                                    return value;
                                }
                            },
                            value: {
                                formatter: (value) => {
                                    return `$${numberWithCommas(value)}`;
                                }
                            }
                        }
                    }
                }
            }
        }



        var chart = new ApexCharts(ctx, options);

        chart.render();
    }
});

function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}